module.exports = __webpack_public_path__ + "static/media/prev-question.31533d0b.svg";